const NONE = "4101e218-4694-11e9-82f6-0242ac120002";
const YIELD_MAINTENANCE = "43c6c288-4694-11e9-82f6-0242ac120002";
const YIELD_MAINTENANCE_AGENCY = "34b6c3bc-82e6-11e9-a53c-0242ac120002";
const LOCKOUT = "39caa91c-82e6-11e9-a53c-0242ac120002";
const MAKE_WHOLE = "46c60d0a-4694-11e9-82f6-0242ac120002";
const FLAT_PERCENTAGE = "530f4ae6-4694-11e9-82f6-0242ac120002";
const DEFEASANCE = "5adc11aa-4694-11e9-82f6-0242ac120002";
const SPREAD_MAINTENANCE = "627e50c1-4694-11e9-82f6-0242ac120002";
const AGGREGATE_INTEREST = "6b1101cc-4694-11e9-82f6-0242ac120002";
export const prepaymentTypes = [
  { name: "Lockout", value: LOCKOUT, sortOrder: 0 },
  { name: "Yield Maintenance", value: YIELD_MAINTENANCE, sortOrder: 1 },
  { name: "Yield Maintenance - Agency Style", value: YIELD_MAINTENANCE_AGENCY, sortOrder: 2 },
  { name: "Make Whole", value: MAKE_WHOLE, sortOrder: 3 },
  { name: "Flat Percentage", value: FLAT_PERCENTAGE, sortOrder: 4 },
  { name: "Defeasance", value: DEFEASANCE, sortOrder: 5 },
  { name: "Spread Maintenance", value: SPREAD_MAINTENANCE, sortOrder: 6 },
  { name: "Aggregate Interest", value: AGGREGATE_INTEREST, sortOrder: 7 },
  { name: "None", value: NONE, sortOrder: 8 }
];
export {
  NONE,
  LOCKOUT,
  YIELD_MAINTENANCE_AGENCY,
  YIELD_MAINTENANCE,
  MAKE_WHOLE,
  FLAT_PERCENTAGE,
  DEFEASANCE,
  SPREAD_MAINTENANCE,
  AGGREGATE_INTEREST
};
